module.exports = __webpack_public_path__ + "static/media/Save to Google Pay - English (Dark).d6395ad1.svg";